import { DataConflictActions } from './DataConflictActions';
import { AnyAction } from 'redux';
import { IGameState } from './IGameState';
import {
    startFetching,
    setConflicts,
    resolveConflicts,
    failedFetchingPlayerData,
    acceptFailedFetchingConflicts,
} from './Action/DataConflict';
import { getType } from 'typesafe-actions';

export const DataConflictReducer = (state: IGameState, action: AnyAction) => {
    switch (action.type) {
        case getType(DataConflictActions.startFetchingConflicts):
            return startFetching(state);
        case getType(DataConflictActions.setConflicts):
            return setConflicts(state, action.payload);
        case getType(DataConflictActions.resolveConflicts):
            return resolveConflicts(state, action.payload);
        case getType(DataConflictActions.failFetchingPlayerData):
            return failedFetchingPlayerData(state);
        case getType(DataConflictActions.acceptFailFetchingPlayerData):
            return acceptFailedFetchingConflicts(state);
        default:
            return state;
    }
};
